module.exports = __webpack_public_path__ + "static/fipcbluepanda1-7ff750d5f88ca57ff8c744738b1a22ab.jpeg";